<template>
  <div style="position: fixed; top: 12px; right: 12px; z-index: 1050">
    <LanguageSwitcher />
  </div>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <!--begin::Authentication - Sign-up -->
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <!--begin::Body-->
      <div
        class="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1"
        style="background: #fafafa"
      >
        <!--begin::Form-->
        <div class="d-flex flex-center flex-column flex-lg-row-fluid">
          <!--begin::Wrapper-->
          <div class="p-2 w-lg-700px" style="width: 95%; max-width: 700px">
            <!--begin::Form-->
            <div class="p-2">
              <h1 class="mb-5 text-center">
                {{ $t("auth.create_account_title") }}
              </h1>
              <hr />
              <h1
                class="mb-5 text-center text-light"
                style="
                  font-weight: 700;
                  font-size: larger;
                  color: #29ca50 !important;
                "
              >
                {{ $t("common.app_name") }}
              </h1>
              <div class="loader-login-box text-center" v-if="loading">
                <h6 style="color: #10ce36">{{ $t("common.please_wait") }}</h6>
                <div
                  class="spinner-border spinner-border-lg text-light"
                  role="status"
                  style="color: #6dff89 !important; height: 120px; width: 120px"
                >
                  <span class="sr-only">{{ $t("common.loading") }}</span>
                </div>
              </div>
              <form
                @submit.prevent="submitForm"
                class="form-horizontal loginWithoutOtp"
                v-if="!loading"
              >
                <div class="row g-3" dir="rtl">
                  <!-- Row 1: Name (full width) -->
                  <div class="col-12">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="name"
                        ><i class="fas fa-user"></i>
                        {{ $t("auth.name") }}</label
                      >
                      <input
                        type="text"
                        v-model="name"
                        class="form-control"
                        id="name"
                        :placeholder="$t('auth.enter_name')"
                      />
                      <small v-if="errors.name" class="text-danger">{{
                        errors.name
                      }}</small>
                    </div>
                  </div>

                  <!-- Row 1.5: Profile Image (optional) -->
                  <div class="col-12">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="user_img">
                        <i class="fas fa-camera"></i>
                        {{ $t("auth.profile_image_optional") }}
                      </label>
                      <div class="image-upload-wrapper">
                        <div class="image-preview" v-if="imagePreview">
                          <img :src="imagePreview" alt="Preview" />
                          <button type="button" class="remove-image-btn" @click="removeImage">
                            <i class="fas fa-times"></i>
                          </button>
                        </div>
                        <div class="image-upload-box" v-else @click="triggerImageUpload">
                          <i class="fas fa-cloud-upload-alt"></i>
                          <span>{{ $t("auth.click_to_upload") }}</span>
                          <small>{{ $t("auth.image_requirements") }}</small>
                        </div>
                        <input
                          type="file"
                          ref="imageInput"
                          @change="handleImageChange"
                          accept=".jpg,.jpeg,.png,.bmp,.tiff"
                          class="hidden-input"
                          id="user_img"
                        />
                      </div>
                      <small v-if="errors.user_img" class="text-danger">{{
                        errors.user_img
                      }}</small>
                    </div>
                  </div>

                  <!-- Row 2: Phone + Password (side by side) -->
                  <div class="col-md-6">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="mobile"
                        ><i class="fas fa-phone"></i>
                        {{ $t("auth.phone") }}</label
                      >
                      <input
                        type="tel"
                        v-model="mobile"
                        class="form-control"
                        id="mobile"
                        maxlength="10"
                      />
                      <small v-if="errors.mobile" class="text-danger">{{
                        errors.mobile
                      }}</small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="password"
                        ><i class="fas fa-lock"></i>
                        {{ $t("auth.password") }}</label
                      >
                      <input
                        type="password"
                        v-model="password"
                        class="form-control"
                        id="password"
                        placeholder="..........."
                      />
                      <small v-if="errors.password" class="text-danger">{{
                        errors.password
                      }}</small>
                    </div>
                  </div>

                  <!-- Row 3: Email (full width) -->
                  <div class="col-12">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="email"
                        ><i class="fas fa-envelope"></i>
                        {{ $t("auth.email_optional") }}</label
                      >
                      <input
                        type="email"
                        v-model="email"
                        class="form-control"
                        id="email"
                        :placeholder="$t('auth.enter_email')"
                      />
                      <small v-if="errors.email" class="text-danger">{{
                        errors.email
                      }}</small>
                    </div>
                  </div>

                  <!-- Row 4: Level + Education (side by side) -->
                  <div class="col-md-6">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="level-select"
                        ><i class="fas fa-layer-group"></i>
                        {{ $t("auth.level") }}
                        <i
                          v-if="infoDataLoader == true"
                          class="fa fa-spinner fa-spin"
                          style="font-size: 14px; color: #00c444"
                        ></i
                      ></label>
                      <select
                        v-model="selectedLevel"
                        class="form-control"
                        id="level-select"
                        @change="onLevelChange"
                      >
                        <option value="" disabled>
                          {{ $t("auth.choose_level") }}
                        </option>
                        <option
                          v-for="level in levels"
                          :key="level.id"
                          :value="level.id"
                        >
                          {{ level.name }}
                        </option>
                      </select>
                      <small v-if="errors.selectedLevel" class="text-danger">{{
                        errors.selectedLevel
                      }}</small>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="education-select"
                        ><i class="fas fa-graduation-cap"></i>
                        {{ $t("auth.education") }}
                      </label>
                      <select
                        v-model="selectedEducation"
                        class="form-control"
                        id="education-select"
                        :disabled="!selectedLevel"
                      >
                        <option v-if="!filteredEducations.length" :value="null">
                          ...
                        </option>
                        <option v-else value="" disabled>
                          {{ $t("auth.choose_education") }}
                        </option>
                        <option
                          v-for="education in filteredEducations"
                          :key="education.id"
                          :value="education.id"
                        >
                          {{ education.name }}
                        </option>
                      </select>
                      <small
                        v-if="errors.selectedEducation"
                        class="text-danger"
                        >{{ errors.selectedEducation }}</small
                      >
                    </div>
                  </div>

                  <!-- Row 5: Year (full width or half) -->
                  <div class="col-md-6">
                    <div class="form-group form-group-custom" dir="rtl">
                      <label for="year-select"
                        ><i class="fas fa-calendar-alt"></i>
                        {{ $t("auth.year") }}</label
                      >
                      <select
                        v-model="selectedYear"
                        class="form-control"
                        id="year-select"
                      >
                        <option value="" disabled>
                          {{ $t("auth.choose_year") }}
                        </option>
                        <option
                          v-for="year in years"
                          :key="year.id"
                          :value="year.id"
                        >
                          {{ year.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Row 6: Privacy checkbox (full width) -->
                  <div class="col-12">
                    <div class="fv-row fv-plugins-icon-container">
                      <label class="form-check form-check-inline">
                        <input
                          v-model="acceptPrivacy"
                          class="form-check-input"
                          type="checkbox"
                          name="toc"
                          value="1"
                        />
                        <span
                          class="form-check-label fw-semibold text-gray-700 fs-base ms-1"
                          >{{ $t("auth.by_registering_i_agree") }}
                          <a
                            href="#"
                            class="ms-1 link-success"
                            data-bs-toggle="modal"
                            data-bs-target="#privacyModal"
                            >{{ $t("auth.terms_and_privacy") }}</a
                          ></span
                        >
                      </label>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      ></div>
                      <small v-if="errors.acceptPrivacy" class="text-danger">{{
                        errors.acceptPrivacy
                      }}</small>
                    </div>
                  </div>

                  <!-- Row 7: Submit button (full width) -->
                  <div class="col-12">
                    <div class="d-grid gap-2">
                      <div class="mt-2 login">
                        <button
                          class="p-3 btn btn-success btn-block waves-effect waves-light"
                          style="
                            height: 55px;
                            background: #31d15f;
                            font-weight: 700;
                            font-size: 19px;
                            width: 100%;
                          "
                          type="submit"
                        >
                          {{ $t("auth.create_account") }}
                          <i class="fa-solid fa-user-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Row 8: Links (full width) -->
                  <div class="col-12">
                    <hr />
                    <div class="text-gray-500 text-center fw-semibold fs-6">
                      {{ $t("auth.have_account") }}
                      <a
                        href="login"
                        class="link-success fw-semibold"
                        style="font-weight: 700 !important"
                        >{{ $t("common.login") }}</a
                      >
                      <br /><br />
                      <div class="mt-2 text-center">
                        <a
                          href="privacy-policy"
                          target="_blank"
                          class="text-muted"
                          ><i class="mdi mdi-shield-check"></i>
                          {{ $t("common.privacy_policy") }}
                        </a>
                        |
                        <a
                          href="terms-of-service"
                          target="_blank"
                          class="text-muted"
                          ><i class="mdi mdi-file-document"></i>
                          {{ $t("common.terms_of_service") }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end::Wrapper-->
        </div>
        <!--end::Form-->
        <!--begin::Footer-->
        <div class="w-lg-500px d-flex flex-stack px-10 mx-auto">
          <!--begin::Languages-->
          <div class="me-10"></div>
          <!--end::Languages-->
        </div>
        <!--end::Footer-->
      </div>
      <!--end::Body-->
      <!--begin::Aside-->
      <div
        class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        style="background: #fff"
      >
        <!--begin::Content-->
        <div
          class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100"
        >
          <!--begin::Logo-->
          <a href="#" class="mb-0 mb-lg-12">
            <img
              alt="Logo"
              src="assets/img/logo-dark.png"
              class="h-60px h-lg-75px"
            />
          </a>
          <!--end::Logo-->
          <!--begin::Image-->
          <img
            class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            src="assets/img/register.gif"
            alt=""
          />
          <!--end::Image-->
          <!--begin::Title-->
          <h1
            class="d-none d-lg-block text-success fs-2qx fw-bolder text-center mb-7"
          >
            {{ $t("auth.tagline") }}
          </h1>
          <!--end::Title-->
          <!--begin::Text-->
          <div class="d-none d-lg-block text-success fs-base text-center">
            {{ $t("auth.promo_text") }}
          </div>
          <!--end::Text-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Aside-->
    </div>
    <!--end::Authentication - Sign-up-->
  </div>
  <!---------------Privacy Policy Modal----------------------------------------->
  <div
    dir="rtl"
    class="modal fade privacy-modal"
    id="privacyModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="privacyModalTitle"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      role="document"
    >
      <div class="modal-content privacy-modal-content">
        <!-- Header with gradient -->
        <div class="modal-header privacy-modal-header">
          <div class="modal-header-icon">
            <i class="fas fa-shield-alt"></i>
          </div>
          <h5 class="modal-title" id="privacyModalTitle">
            {{ $t("common.privacy_policy") }}
          </h5>
          <button
            type="button"
            class="btn-close-custom"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body privacy-modal-body">
          <!-- Logo -->
          <div class="modal-logo-wrapper">
            <img alt="Logo" src="assets/img/logo-dark.png" class="modal-logo" />
          </div>

          <!-- Intro -->
          <div class="policy-intro">
            <i class="fas fa-info-circle"></i>
            <h4>{{ $t("auth.policy_intro") }}</h4>
          </div>

          <!-- Policy Items -->
          <div class="policy-list">
            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-clock"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_course_duration_title") }}</strong>
                <p>{{ $t("auth.policy_course_duration_text") }}</p>
              </div>
            </div>

            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-undo-alt"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_refund_title") }}</strong>
                <p>{{ $t("auth.policy_refund_text") }}</p>
              </div>
            </div>

            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-mobile-alt"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_devices_title") }}</strong>
                <p>{{ $t("auth.policy_devices_text") }}</p>
              </div>
            </div>

            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-play-circle"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_playback_title") }}</strong>
                <p>{{ $t("auth.policy_playback_text") }}</p>
              </div>
            </div>

            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_exceptional_title") }}</strong>
                <p>{{ $t("auth.policy_exceptional_text") }}</p>
              </div>
            </div>

            <div class="policy-item">
              <div class="policy-item-icon">
                <i class="fas fa-user-check"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_verification_title") }}</strong>
                <p>{{ $t("auth.policy_verification_text") }}</p>
              </div>
            </div>

            <div class="policy-item policy-item-contact">
              <div class="policy-item-icon">
                <i class="fas fa-headset"></i>
              </div>
              <div class="policy-item-content">
                <strong>{{ $t("auth.policy_contact_title") }}</strong>
                <p>
                  {{ $t("auth.policy_contact_text") }}
                  <a href="tel:0913103064" class="contact-link">
                    <i class="fas fa-phone"></i> 0913103064
                  </a>
                </p>
              </div>
            </div>
          </div>

          <!-- Closing text -->
          <div class="policy-closing">
            <i class="fas fa-check-circle"></i>
            <p>{{ $t("auth.policy_closing_text") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hashV2 } from "@/utils/api";
import QRCode from "qrcodejs2";
import Swal from "sweetalert2";

import "../assets/blockui";
import { apiUrl, deviceId, baseUrl, getBrowserName } from "@/utils/api";
import LanguageSwitcher from "@/components/LanguageSwitcher.vue";
import i18n from "@/plugins/i18n";
var iti;
var phone;

export default {
  components: {
    LanguageSwitcher,
  },
  data() {
    return {
      name: "",
      email: "",
      mobile: "",
      password: "",
      acceptPrivacy: "",
      selectedLevel: null,
      selectedEducation: null,
      selectedYear: null,
      loading: false,
      infoDataLoader: true,
      errors: {},
      userImage: null,
      imagePreview: null,
    };
  },
  computed: {
    filteredEducations() {
      if (this.selectedLevel) {
        const level = this.levels.find((l) => l.id === this.selectedLevel);
        return level ? level.educations : [];
      }
      return [];
    },
  },
  mounted() {
    phone = document.querySelector("#mobile");
    $(document).ready(function () {
      iti = intlTelInput(phone, {
        utilsScript: "assets/js/utils.js",
        initialCountry: "ly", // Set Libya as the default country
        separateDialCode: true,
        excludeCountries: ["il"],
        customPlaceholder: function (
          selectedCountryPlaceholder,
          selectedCountryData
        ) {
          // Remove leading 0 from placeholder (e.g., 0922345678 -> 922345678)
          return selectedCountryPlaceholder.replace(/^0/, "");
        },
      });
    });
    // Fetch the data from the API
    this.fetchData();
  },
  methods: {
    fetchData() {
      $.ajax({
        url: apiUrl + "/get-info-data", // Replace with your actual API URL
        method: "GET",
        dataType: "json",
        success: (response) => {
          this.infoDataLoader = false;
          this.levels = response.levels;
          this.years = response.years;
        },
        error: (error) => {
          console.error("Error fetching data:", error);
        },
      });
    },
    onLevelChange() {
      this.selectedEducation = null; // Reset education when level changes
    },
    triggerImageUpload() {
      this.$refs.imageInput.click();
    },
    handleImageChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!allowedTypes.includes(file.type)) {
        this.errors.user_img = i18n.global.t("auth.invalid_image_type");
        return;
      }

      // Validate file size (max 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        this.errors.user_img = i18n.global.t("auth.image_too_large");
        return;
      }

      this.errors.user_img = null;
      this.userImage = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage() {
      this.userImage = null;
      this.imagePreview = null;
      if (this.$refs.imageInput) {
        this.$refs.imageInput.value = '';
      }
    },
    validateForm() {
      const errors = {};

      if (!this.name) errors.name = "الاسم مطلوب";
      if (this.email && !/\S+@\S+\.\S+/.test(this.email))
        errors.email = "البريد الإلكتروني غير صحيح";
      if (!this.mobile || !/^(09\d{8}|\d{9})$/.test(this.mobile)) {
        errors.mobile = "رقم الهاتف غير صحيح";
      }
      if (!this.password) errors.password = "كلمة المرور مطلوبة";
      if (!this.selectedLevel) errors.selectedLevel = "المستوى مطلوب";

      // شرط للتعليم: السماح بأن يكون null فقط في حال عدم وجود تخصصات متاحة
      if (!this.selectedEducation && this.filteredEducations.length > 0) {
        errors.selectedEducation = "التعليم مطلوب";
      }

      if (!this.selectedYear) errors.selectedYear = "السنة مطلوبة";
      if (!this.acceptPrivacy)
        errors.acceptPrivacy = "يجب الموافقة على سياسة الخصوصية";

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },

    submitForm() {
      if (!this.validateForm()) return;

      const webInfo = {
        id: "device_id", // قم بتحديث هذا الحقل حسب الحاجة
        brand: "device_brand", // قم بتحديث هذا الحقل حسب الحاجة
      };

      const now = new Date();

      // Use FormData if image is present, otherwise use regular object
      let formData;
      let ajaxOptions;

      if (this.userImage) {
        // Use FormData for multipart/form-data
        formData = new FormData();
        formData.append("name", this.name);
        formData.append("password", this.password);
        formData.append("mobile", iti.getNumber());
        formData.append("device_name", webInfo.brand);
        formData.append("device_id", deviceId + "//" + getBrowserName());
        formData.append("country_code", "+" + iti.getSelectedCountryData().dialCode);
        formData.append("level_id", this.selectedLevel);
        formData.append("location", "0");
        formData.append("education_id", this.selectedEducation || "");
        formData.append("year_id", this.selectedYear);
        formData.append("guest", "0");
        formData.append("user_img", this.userImage);
        
        if (this.email) {
          formData.append("email", this.email);
        }

        ajaxOptions = {
          url: apiUrl + "/register",
          method: "POST",
          data: formData,
          processData: false,
          contentType: false,
        };
      } else {
        // Use regular object without image
        let data = {
          name: this.name,
          password: this.password,
          mobile: iti.getNumber(),
          device_name: webInfo.brand,
          device_id: deviceId + "//" + getBrowserName(),
          country_code: "+" + iti.getSelectedCountryData().dialCode,
          level_id: this.selectedLevel,
          location: "0",
          education_id: this.selectedEducation,
          year_id: this.selectedYear,
          guest: "0",
        };

        if (this.email) {
          data.email = this.email;
        }

        ajaxOptions = {
          url: apiUrl + "/register",
          method: "POST",
          data: data,
        };
      }

      // عرض BlockUI
      $(".loginWithoutOtp-box").block({
        message: `<span style="margin:0px;padding:8px;font-size:18px;color:#29ca50;">${i18n.global.t(
          "common.please_wait"
        )}</span>`,
        css: {
          backgroundColor: "rgba(255, 255, 255, 0.8)", // خلفية بيضاء شفافة
          color: "#000", // لون النص الافتراضي
          border: "0px",
          padding: "15px",
          "-webkit-border-radius": "10px",
          "-moz-border-radius": "10px",
          opacity: 1,
        },
        overlayCSS: {
          backgroundColor: "rgb(204 204 204 / 80%)", // تغيير لون الخلفية overlay إلى أبيض شفاف
          opacity: 0.8, // يمكنك ضبط الشفافية هنا
          cursor: "wait",
        },
      });
      $.ajax({
        ...ajaxOptions,
        success: (response) => {
          this.loading = false;
          //localStorage.setItem("access_token", response.access_token);
          //localStorage.setItem("expires_in", response.expires_in);

          // إخفاء BlockUI

          // عرض SweetAlert ترحيبي
          Swal.fire({
            title: i18n.global.t("auth.register_success_title"),
            text: i18n.global.t("auth.register_success_text"),
            icon: "success",
            confirmButtonText: i18n.global.t("common.ok"),
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.href = "/login"; // الانتقال إلى صفحة الرئيسية
            }
          });
        },
        error: (error) => {
          this.loading = false;

          let errorMessage = i18n.global.t("auth.unexpected_error");

          // التحقق من وجود الرسالة في responseJSON
          if (error.responseJSON && error.responseJSON.message) {
            errorMessage = error.responseJSON.message; // الرسالة من responseJSON
          } else if (error.responseText) {
            try {
              let errorData = JSON.parse(error.responseText); // محاولة تحويل responseText إلى JSON
              errorMessage = errorData.message || errorMessage; // استخدام الرسالة إن وجدت
            } catch (e) {
              console.error("Error parsing responseText:", e);
            }
          }

          Swal.fire({
            title: i18n.global.t("auth.register_error_title"),
            text: errorMessage, // عرض رسالة الخطأ
            icon: "error", // أيقونة خطأ
            confirmButtonText: i18n.global.t("common.ok"),
          });

          $(".loginWithoutOtp-box").unblock();
          console.error("Error creating account:", error);
        },
      });
    },
  },
};
</script>
<style scoped>
/* ========== Animations ========== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes bubbleFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-20px) scale(1.1);
    opacity: 0.8;
  }
}

@keyframes bubbleFloat2 {
  0%,
  100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translateY(-30px) translateX(10px) scale(1.15);
    opacity: 0.7;
  }
}

@keyframes bubbleFloat3 {
  0%,
  100% {
    transform: translateY(0) translateX(0) scale(1);
    opacity: 0.4;
  }
  50% {
    transform: translateY(-15px) translateX(-10px) scale(1.05);
    opacity: 0.6;
  }
}

/* ========== Main Container ========== */
#kt_app_root {
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

@keyframes circleFloat1 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(40px, 30px);
  }
}

@keyframes circleFloat2 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-30px, 40px);
  }
}

@keyframes circleFloat3 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(25px, -35px);
  }
}

@keyframes circleFloat4 {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-40px, -25px);
  }
}

/* ========== Left Side - Form ========== */
.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1 {
  background: #f5f5f5 !important;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

/* Multiple floating circles on left side only */
.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1::before {
  content: "";
  position: absolute;
  width: 250px;
  height: 250px;
  background: rgba(0, 196, 68, 0.1);
  border-radius: 50%;
  top: -50px;
  left: -50px;
  pointer-events: none;
  animation: circleFloat1 10s ease-in-out infinite;
}

.d-flex.flex-column.flex-lg-row-fluid.w-lg-50.order-2.order-lg-1::after {
  content: "";
  position: absolute;
  width: 180px;
  height: 180px;
  background: rgba(0, 196, 68, 0.08);
  border-radius: 50%;
  bottom: 10%;
  left: 20%;
  pointer-events: none;
  animation: circleFloat2 12s ease-in-out infinite;
}

/* Additional circles using box-shadow trick */
.d-flex.flex-center.flex-column.flex-lg-row-fluid {
  position: relative;
}

.d-flex.flex-center.flex-column.flex-lg-row-fluid::before {
  content: "";
  position: absolute;
  width: 120px;
  height: 120px;
  background: rgba(0, 196, 68, 0.07);
  border-radius: 50%;
  top: 20%;
  right: 5%;
  pointer-events: none;
  animation: circleFloat3 8s ease-in-out infinite;
}

.d-flex.flex-center.flex-column.flex-lg-row-fluid::after {
  content: "";
  position: absolute;
  width: 200px;
  height: 200px;
  background: rgba(0, 196, 68, 0.06);
  border-radius: 50%;
  bottom: -30px;
  right: -30px;
  pointer-events: none;
  animation: circleFloat4 14s ease-in-out infinite;
}

/* ========== Form Wrapper ========== */
.p-2.w-lg-700px {
  animation: fadeInUp 0.8s ease forwards;
  position: relative;
  z-index: 1;
  width: 95% !important;
  max-width: 700px !important;
}

.p-2.w-lg-700px > .p-2 {
  background: #ffffff;
  border: none;
  border-radius: 24px;
  padding: 30px 28px !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.1), 0 10px 30px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

/* Decorative top accent line */
.p-2.w-lg-700px > .p-2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(
    90deg,
    #00c444,
    #00e050,
    #00ff6a,
    #00e050,
    #00c444
  );
  background-size: 200% 100%;
  animation: shimmer 3s linear infinite;
}

/* Decorative corner accent */
.p-2.w-lg-700px > .p-2::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: radial-gradient(
    circle at top right,
    rgba(0, 196, 68, 0.08) 0%,
    transparent 70%
  );
  pointer-events: none;
}

/* ========== Titles ========== */
.p-2 > h1.mb-5.text-center:first-of-type {
  font-size: 1.6rem !important;
  font-weight: 800 !important;
  color: #1a1a2e !important;
  margin-bottom: 10px !important;
}

.p-2 > hr {
  border: none;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(0, 196, 68, 0.4),
    transparent
  );
  margin: 12px 0;
}

.p-2 > h1.text-light {
  font-size: 1.2rem !important;
  color: #00c444 !important;
  font-weight: 700 !important;
  margin-bottom: 16px !important;
}

/* ========== Loading Spinner ========== */
.loader-login-box {
  padding: 40px 0;
}

.loader-login-box h6 {
  color: #00e050 !important;
  font-size: 1.1rem;
  margin-bottom: 20px;
  text-shadow: 0 0 20px rgba(0, 224, 80, 0.5);
}

.loader-login-box .spinner-border {
  color: #00e050 !important;
  width: 80px !important;
  height: 80px !important;
  border-width: 4px;
  animation: pulse 1.5s ease infinite;
}

/* ========== Form Controls ========== */
.form-control {
  height: 48px;
  font-size: 15px;
  width: 100%;
  background: #ffffff !important;
  border: 2px solid #e8e8e8 !important;
  border-radius: 12px !important;
  color: #1a1a2e !important;
  padding: 10px 14px;
  padding-right: 40px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.form-group-custom.mb-4 {
  margin-bottom: 14px !important;
}

.form-control::placeholder {
  color: #a0a0a0;
  font-size: 14px;
}

.form-control:hover:not(:focus) {
  border-color: #c5e8d0 !important;
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.08);
}

.form-control:focus {
  background: #ffffff !important;
  border-color: #00c444 !important;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.12), 0 4px 12px rgba(0, 196, 68, 0.1) !important;
  outline: none;
  transform: translateY(-1px);
}

/* Select dropdown arrow */
select.form-control {
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2300c444' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: left 14px center !important;
  background-size: 12px !important;
  padding-left: 36px !important;
}

select.form-control:disabled {
  background-color: #f5f5f5 !important;
  cursor: not-allowed;
  opacity: 0.7;
}

/* ========== Labels with Icons ========== */
.form-group-custom {
  position: relative;
}

.form-group-custom label {
  color: #374151 !important;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-group-custom label i {
  color: #00c444;
  font-size: 0.85rem;
}

/* ========== Image Upload ========== */
.image-upload-wrapper {
  position: relative;
}

.hidden-input {
  display: none;
}

.image-upload-box {
  border: 2px dashed #c5e8d0;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
}

.image-upload-box:hover {
  border-color: #00c444;
  background: linear-gradient(145deg, #f0fff5 0%, #e8fff1 100%);
  transform: translateY(-2px);
}

.image-upload-box i {
  font-size: 2.5rem;
  color: #00c444;
  display: block;
  margin-bottom: 10px;
}

.image-upload-box span {
  display: block;
  color: #374151;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.image-upload-box small {
  display: block;
  color: #9ca3af;
  font-size: 0.8rem;
}

.image-preview {
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.image-preview img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid #00c444;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.25);
}

.remove-image-btn {
  position: absolute;
  top: 0;
  right: calc(50% - 70px);
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
  transition: all 0.3s ease;
}

.remove-image-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(239, 68, 68, 0.5);
}

/* ========== Register Button ========== */
.login button.btn-success {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  height: 52px !important;
  box-shadow: 0 8px 30px rgba(0, 224, 80, 0.3);
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}

.mt-4.login {
  margin-top: 16px !important;
}

.fv-row.mb-8 {
  margin-bottom: 16px !important;
}

.login button.btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.login button.btn-success:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 224, 80, 0.4);
}

.login button.btn-success:hover::before {
  left: 100%;
}

/* ========== Links ========== */
.text-muted {
  color: #6b7280 !important;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.95rem;
}

.text-muted:hover {
  color: #00c444 !important;
}

/* Link icons - Font Awesome */
.text-muted i.fas,
.text-muted i.mdi {
  font-size: 1rem;
  color: #00c444;
  margin-left: 6px;
}

.text-muted:hover i.fas,
.text-muted:hover i.mdi {
  color: #00a838;
}

.link-success {
  color: #00c444 !important;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.link-success:hover {
  color: #00a838 !important;
  text-decoration: underline;
}

/* ========== Checkbox ========== */
.form-check-input {
  width: 22px;
  height: 22px;
  border: 2px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 10px;
}

.form-check-input:hover {
  border-color: #00c444;
  box-shadow: 0 0 0 3px rgba(0, 196, 68, 0.1);
}

.form-check-input:checked {
  background-color: #00c444;
  border-color: #00c444;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.15);
}

.form-check-label {
  color: #4b5563;
  font-size: 0.9rem;
  line-height: 1.5;
}

.fv-row {
  background: linear-gradient(
    135deg,
    rgba(0, 196, 68, 0.03) 0%,
    rgba(0, 196, 68, 0.01) 100%
  );
  border: 1px solid rgba(0, 196, 68, 0.1);
  border-radius: 12px;
  padding: 14px 16px;
}

/* ========== Error Messages ========== */
.text-danger {
  background: linear-gradient(
    135deg,
    rgba(239, 68, 68, 0.1) 0%,
    rgba(239, 68, 68, 0.05) 100%
  );
  border: 1px solid rgba(239, 68, 68, 0.2);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
  margin-top: 6px;
  display: inline-block;
  color: #dc2626 !important;
}

/* ========== Right Side - Branding ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 {
  background: #ffffff !important;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

/* ========== Logo ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 a.mb-0.mb-lg-12 img {
  filter: drop-shadow(0 10px 30px rgba(0, 196, 68, 0.2));
  transition: all 0.3s ease;
}

.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 a.mb-0.mb-lg-12:hover img {
  transform: scale(1.05);
  filter: drop-shadow(0 15px 40px rgba(0, 196, 68, 0.3));
}

/* ========== Illustration ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 img.mx-auto {
  animation: float 4s ease-in-out infinite;
  filter: none;
}

/* ========== Tagline ========== */
.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 h1.text-success {
  color: #00c444 !important;
  font-weight: 800 !important;
  text-shadow: 0 4px 20px rgba(0, 196, 68, 0.2);
}

.d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 .text-success.fs-base {
  color: #047857 !important;
  font-size: 1.1rem !important;
  line-height: 1.8;
}

/* ========== Privacy Modal Styling ========== */
.privacy-modal .modal-dialog {
  max-width: 650px;
}

.privacy-modal-content {
  background: #ffffff !important;
  border: none !important;
  border-radius: 24px !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 196, 68, 0.1);
  overflow: hidden;
}

/* Modal Header */
.privacy-modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a838 100%) !important;
  border-bottom: none !important;
  padding: 24px 28px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.privacy-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.modal-header-icon {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
}

.modal-header-icon i {
  font-size: 1.3rem;
  color: #ffffff;
}

.privacy-modal-header .modal-title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
}

.privacy-modal-header .modal-title i {
  font-size: 1.1rem;
  opacity: 0.9;
}

.btn-close-custom {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-close-custom i {
  color: #ffffff;
  font-size: 1rem;
}

.btn-close-custom:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: rotate(90deg);
}

/* Modal Body */
.privacy-modal-body {
  padding: 28px;
  max-height: 60vh;
  overflow-y: auto;
}

.modal-logo-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.modal-logo {
  height: 60px;
  filter: drop-shadow(0 4px 12px rgba(0, 196, 68, 0.2));
}

/* Policy Intro */
.policy-intro {
  background: linear-gradient(
    135deg,
    rgba(0, 196, 68, 0.08) 0%,
    rgba(0, 196, 68, 0.03) 100%
  );
  border: 1px solid rgba(0, 196, 68, 0.15);
  border-radius: 14px;
  padding: 16px 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.policy-intro i {
  font-size: 1.5rem;
  color: #00c444;
}

.policy-intro h4 {
  margin: 0;
  color: #374151;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.6;
}

/* Policy List */
.policy-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.policy-item {
  display: flex;
  gap: 14px;
  padding: 14px 16px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.policy-item:hover {
  background: #f0fdf4;
  border-color: rgba(0, 196, 68, 0.2);
  transform: translateX(-4px);
}

.policy-item-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: linear-gradient(135deg, #00c444 0%, #00a838 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.25);
}

.policy-item-icon i {
  color: #ffffff;
  font-size: 1rem;
}

.policy-item-content {
  flex: 1;
}

.policy-item-content strong {
  display: block;
  color: #1a1a2e;
  font-size: 0.95rem;
  margin-bottom: 4px;
}

.policy-item-content p {
  margin: 0;
  color: #6b7280;
  font-size: 0.88rem;
  line-height: 1.6;
}

.policy-item-contact {
  background: linear-gradient(
    135deg,
    rgba(0, 196, 68, 0.05) 0%,
    rgba(0, 196, 68, 0.02) 100%
  );
  border-color: rgba(0, 196, 68, 0.15);
}

.contact-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #00c444 !important;
  font-weight: 600;
  text-decoration: none;
  background: rgba(0, 196, 68, 0.1);
  padding: 4px 12px;
  border-radius: 20px;
  margin-top: 6px;
  transition: all 0.3s ease;
}

.contact-link:hover {
  background: #00c444;
  color: #ffffff !important;
}

.contact-link i {
  font-size: 0.8rem;
}

/* Policy Closing */
.policy-closing {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid rgba(0, 196, 68, 0.2);
  border-radius: 14px;
  padding: 16px 20px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.policy-closing i {
  font-size: 1.8rem;
  color: #00c444;
}

.policy-closing p {
  margin: 0;
  color: #047857;
  font-size: 0.95rem;
  font-weight: 500;
  flex: 1;
}

/* Modal Footer */
.privacy-modal-footer {
  background: #f9fafb;
  border-top: 1px solid #f0f0f0 !important;
  padding: 18px 28px;
  display: flex;
  justify-content: center;
}

.btn-accept {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  border: none !important;
  color: #ffffff !important;
  border-radius: 12px;
  padding: 12px 40px;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 6px 20px rgba(0, 196, 68, 0.3);
  transition: all 0.3s ease;
}

.btn-accept:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 196, 68, 0.4);
}

.btn-accept i {
  font-size: 0.9rem;
}

/* Modal Scrollbar */
.privacy-modal-body::-webkit-scrollbar {
  width: 6px;
}

.privacy-modal-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.privacy-modal-body::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00c444, #00a838);
  border-radius: 10px;
}

/* ========== Language Switcher ========== */
div[style*="position: fixed; top: 12px; right: 12px"] {
  z-index: 1050;
}

/* ========== International Phone Input ========== */
.iti {
  width: 100%;
}

.iti__flag-container {
  background: #f8f9fa;
  border-radius: 14px 0 0 14px;
}

.iti__selected-flag {
  background: transparent !important;
  border-radius: 14px 0 0 14px;
}

.iti__selected-dial-code {
  color: #00c444 !important;
}

/* ========== Responsive ========== */
@media (max-width: 991.98px) {
  .p-2.w-lg-700px {
    width: 95% !important;
    max-width: none !important;
  }

  .p-2.w-lg-700px > .p-2 {
    padding: 24px 18px !important;
    border-radius: 20px;
  }

  .d-flex.flex-lg-row-fluid.w-lg-50.order-1.order-lg-2 {
    padding: 20px 15px !important;
  }

  /* Stack fields on mobile */
  .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
